window.__tnt || (window.__tnt = {});

__tnt.infinityStoryFetcher = (function(){
    var Fetcher = function (options) {
        var lib = {};

        // private properties
        var order;
        var origin_id;
        var origin_url;
        var found_origin = false;
        var first_id = null;
        var first_run = true;
        var type;
        var next_url = null;
        var assets_to_fetch = 3;

        // public properties
        lib.finished = false;
        lib.assets = [];

        // public methods
        lib.init = function(options) {
            order = (options.order == 'latest') ? 'latest' : 'next';
            origin_id = options.origin_id;
            origin_url = options.url;
            type = (options.type == 'nav') ? 'nav' : 'content';
            if (Number.isInteger(options.assets_to_fetch)) assets_to_fetch = options.assets_to_fetch;
        };

        lib.fetch = function(callback) {
            if (lib.finished) return;
            if (order == 'next') {
                lib.fetchNext(callback);
            } else {
                lib.fetchLatest(callback);
            }
        };

        lib.fetchLatest = function(callback) {
            var url;
            if (next_url === null) {
                url = origin_url;
            } else {
                url = next_url;
            }

            url = __tnt.scrubUrl(url);

            if (lib.assets.length >= 3) {
                var assets = lib.assets.splice(0, 3);
                var fetch_event = new CustomEvent('infinity-story-fetch', {
                    detail: {
                        type: type,
                        assets: assets
                    }
                });
                document.dispatchEvent(fetch_event);

                if (typeof callback === 'function') callback();

            } else {
                var assets = lib.assets.splice(0, lib.assets.length);

                fetch(url, {credentials:'same-origin'})
                .then(function(response) {
                    if (response.status !== 200) {
                        console.log('Infinity Fetch Error. Status Code: ' + response.status);
                        return;
                    }

                    response.json().then(function(data) {
                        if (data.next_url !== null) {
                            next_url = data.next_url;
                        } else {
                            next_url = null;
                        }

                        if (typeof data.assets != 'undefined' && data.assets.length > 0) {
                            // if there are assets
                            data.assets.forEach(function(asset, index) {
                                if (asset.id !== origin_id) {
                                    lib.assets.push(asset);
                                }
                            });

                            if (typeof callback === 'function') callback();

                            while(assets.length < 3 && lib.assets.length > 0) {
                                assets.push(lib.assets.splice(0,1)[0]);
                            }

                            // Register and dispatch custom event
                            var fetch_event = new CustomEvent('infinity-story-fetch', {
                                detail: {
                                    type: type,
                                    assets: assets
                                }
                            });
                            document.dispatchEvent(fetch_event);
                        } else {
                            // if there aren't any assets
                            lib.finished = true;
                            var finished_event = new CustomEvent('infinity-story-fetcher-finished');
                            document.dispatchEvent(finished_event);
                        }
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
            }
        };

        lib.fetchNext = function(callback) {
            var url;
            if (next_url === null) {
                url = origin_url;
            } else {
                url = next_url;
            }

            url = __tnt.scrubUrl(url);

            if (lib.assets.length >= 3) {
                var assets = lib.assets.splice(0, 3);
                var fetch_event = new CustomEvent('infinity-story-fetch', {
                    detail: {
                        type: type,
                        assets: assets
                    }
                });
                document.dispatchEvent(fetch_event);

                if (typeof callback === 'function') callback();

            } else {
                var assets = lib.assets.splice(0, lib.assets.length);

                fetch(url, {credentials:'same-origin'})
                .then(function(response) {
                    if (response.status !== 200) {
                        console.log('Infinity Fetch Error. Status Code: ' + response.status);
                        return;
                    }

                    response.json().then(function(data) {
                        if (data.next_url === null) {
                            next_url = origin_url;
                        } else {
                            next_url = data.next_url;
                        }

                        if (typeof data.assets != 'undefined' && data.assets.length > 0) {
                            data.assets.forEach(function(asset, index) {
                                // found origin once, disply assets
                                if (found_origin == true) {
                                    // found origin twice, all assets found
                                    if (asset.id == origin_id) {
                                        lib.finished = true;
                                        next_url = null;
                                        var finished_event = new CustomEvent('infinity-story-fetcher-finished');
                                        document.dispatchEvent(finished_event);

                                    } else if (lib.finished == false && asset.id != origin_id) {
                                        // append assets to array/object
                                        lib.assets.push(asset);
                                    }
                                } else {
                                    // Origin found. Begin displaying assets
                                    if (asset.id == origin_id) {
                                        found_origin = true;
                                    } else {
                                        // Origin found is false. Skip asset
                                        // Fail-safe in case origin is not present in set. This can be removed when origin is fixed.
                                        if (first_run == true) {
                                            first_id = asset.id;
                                            first_run = false;
                                        } else if (asset.id == first_id) {
                                            // We've started again. Force origin
                                            origin_id = first_id;
                                            found_origin = true;
                                        }
                                    }
                                }
                            });

                            if (typeof callback === 'function') callback();

                            while(assets.length < 3 && lib.assets.length > 0) {
                                assets.push(lib.assets.splice(0,1)[0]);
                            }

                            // Register and dispatch custom event
                            var fetch_event = new CustomEvent('infinity-story-fetch', {
                                detail: {
                                    type: type,
                                    assets: assets
                                }
                            });
                            document.dispatchEvent(fetch_event);

                        } else {
                            // Empty asset set returned. Go back in for a real set
                            lib.fetchNext(next_url);
                        }

                        // Check next URL
                        if (next_url) {
                            // if origin hasn't been found yet and we hit next_url. Trigger the set to pull in again.
                            if (found_origin == false) {
                                // No origin yet. Call the fetch function
                                lib.fetchNext(next_url);
                            }
                        }
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
            }
        };

        // Initialize the plugin
        lib.init(options);

        // Return public APIs
        return lib;
    };

    return Fetcher;
})();